import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Tag,
  Typography,
} from "antd";
import { useState, useCallback, useMemo, useEffect } from "react";
import {
  ReloadOutlined,
  FilterOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import { GET_GEO_ALL, HEADERS_EXPORT_BEN } from "../../API/apiUrls";
import axios from "axios";
import MotionHoc from "../../../utils/MotionHoc";
import SeizeAssetModal from "./modal/SeizeAssetModal";

const { Option } = Select;
const { Text } = Typography;

// ─────────────────────────────────────────────
// MOCK DATA  (land-level, รวม garno 0/1/2 ไว้ด้วยกัน)
// ─────────────────────────────────────────────
const MOCK_ASSETS = [
  /* ===== สัญญา 2-0012446 : หจก. ทีเอ ทรานสปอร์ต (2017) ===== */
  // ผู้เช่าซื้อ — หนองคาย (2 แปลง)
  {
    landId: 1334,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1845,
    invId: 577,
    customerId: 2031,
    investigation: 1,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    ownerName: "หจก.ทีเอ ทรานสปอร์ต (2017)",
    LOCAT: "LEX",
    numberLand: "84644",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
    sequestrateStatus: 0,
    mortgageType: "จำนอง",
  },
  {
    landId: 1335,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1845,
    invId: 577,
    customerId: 2031,
    investigation: 2,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    ownerName: "หจก.ทีเอ ทรานสปอร์ต (2017)",
    LOCAT: "LEX",
    numberLand: "84927",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
    sequestrateStatus: 0,
    mortgageType: null,
  },
  // ผู้เช่าซื้อ — อุดรธานี (แปลงที่ 3 อีกจังหวัด)
  {
    landId: 1336,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1846,
    invId: 577,
    customerId: 2031,
    investigation: 2,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    ownerName: "หจก.ทีเอ ทรานสปอร์ต (2017)",
    LOCAT: "LEX",
    numberLand: "11023",
    typeLand: 1,
    province: "41",
    district: "01",
    subdistrict: "01",
    provDesc: "อุดรธานี",
    distDesc: "อ.เมืองอุดรธานี",
    subDistDesc: "หมากแข้ง",
    sequestrateStatus: 0,
    mortgageType: null,
  },
  // ผู้เช่าซื้อ — กรุงเทพ (นส.3)
  {
    landId: 1337,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1847,
    invId: 577,
    customerId: 2031,
    investigation: 3,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    ownerName: "หจก.ทีเอ ทรานสปอร์ต (2017)",
    LOCAT: "LEX",
    numberLand: "55012",
    typeLand: 2,
    province: "10",
    district: "01",
    subdistrict: "01",
    provDesc: "กรุงเทพมหานคร",
    distDesc: "เขตพระนคร",
    subDistDesc: "พระบรมมหาราชวัง",
    sequestrateStatus: 1,
    mortgageType: null, // ติดอายัด
  },
  // คนค้ำที่ 1 — หนองคาย
  {
    landId: 1338,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1848,
    invId: 577,
    customerId: 2032,
    investigation: 1,
    CUSCOD: "1451400111735",
    SNAM: "นาง",
    NAME1: "อุบลวัลย์",
    NAME2: "ธีระกูล",
    garno: 1,
    ownerName: "นาง อุบลวัลย์ ธีระกูล",
    LOCAT: "LEX",
    numberLand: "84700",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
    sequestrateStatus: 0,
    mortgageType: null,
  },
  // คนค้ำที่ 2 — ขอนแก่น
  {
    landId: 1339,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1849,
    invId: 577,
    customerId: 2033,
    investigation: 1,
    CUSCOD: "1400900223344",
    SNAM: "นาย",
    NAME1: "ประสิทธิ์",
    NAME2: "มั่นคง",
    garno: 2,
    ownerName: "นาย ประสิทธิ์ มั่นคง",
    LOCAT: "LEX",
    numberLand: "60321",
    typeLand: 1,
    province: "40",
    district: "02",
    subdistrict: "03",
    provDesc: "ขอนแก่น",
    distDesc: "อ.บ้านฝาง",
    subDistDesc: "บ้านฝาง",
    sequestrateStatus: 0,
    mortgageType: "ขายฝาก", // ติดขายฝาก
  },

  /* ===== สัญญา 2-0011000 : นาย สมชาย รุ่งเรือง ===== */
  // ผู้เช่าซื้อ — เชียงใหม่
  {
    landId: 2001,
    invRoundId: 90,
    loanId: 901,
    contno: "2-0011000",
    assetOnlineId: 1990,
    invId: 601,
    customerId: 2105,
    investigation: 2,
    CUSCOD: "1100700123456",
    SNAM: "นาย",
    NAME1: "สมชาย",
    NAME2: "รุ่งเรือง",
    garno: 0,
    ownerName: "นาย สมชาย รุ่งเรือง",
    LOCAT: "LEX",
    numberLand: "20455",
    typeLand: 1,
    province: "50",
    district: "01",
    subdistrict: "01",
    provDesc: "เชียงใหม่",
    distDesc: "อ.เมืองเชียงใหม่",
    subDistDesc: "ศรีภูมิ",
    sequestrateStatus: 0,
    mortgageType: "จำนอง",
  },
  // ผู้เช่าซื้อ — สงขลา
  {
    landId: 2002,
    invRoundId: 90,
    loanId: 901,
    contno: "2-0011000",
    assetOnlineId: 1991,
    invId: 601,
    customerId: 2105,
    investigation: 3,
    CUSCOD: "1100700123456",
    SNAM: "นาย",
    NAME1: "สมชาย",
    NAME2: "รุ่งเรือง",
    garno: 0,
    ownerName: "นาย สมชาย รุ่งเรือง",
    LOCAT: "LEX",
    numberLand: "30781",
    typeLand: 1,
    province: "90",
    district: "01",
    subdistrict: "01",
    provDesc: "สงขลา",
    distDesc: "อ.เมืองสงขลา",
    subDistDesc: "บ่อยาง",
    sequestrateStatus: 0,
    mortgageType: null,
  },
  // คนค้ำที่ 1 — เชียงราย
  {
    landId: 2003,
    invRoundId: 90,
    loanId: 901,
    contno: "2-0011000",
    assetOnlineId: 1992,
    invId: 601,
    customerId: 2106,
    investigation: 1,
    CUSCOD: "1570100334455",
    SNAM: "นาง",
    NAME1: "วรรณา",
    NAME2: "พิมพ์ทอง",
    garno: 1,
    ownerName: "นาง วรรณา พิมพ์ทอง",
    LOCAT: "LEX",
    numberLand: "45100",
    typeLand: 1,
    province: "57",
    district: "01",
    subdistrict: "01",
    provDesc: "เชียงราย",
    distDesc: "อ.เมืองเชียงราย",
    subDistDesc: "เวียง",
    sequestrateStatus: 0,
    mortgageType: null,
  },

  /* ===== สัญญา 1-0009999 : นาง วิภา ทองคำ ===== */
  // ผู้เช่าซื้อ — นนทบุรี
  {
    landId: 3001,
    invRoundId: 75,
    loanId: 770,
    contno: "1-0009999",
    assetOnlineId: 1500,
    invId: 540,
    customerId: 1899,
    investigation: 1,
    CUSCOD: "3650400999888",
    SNAM: "นาง",
    NAME1: "วิภา",
    NAME2: "ทองคำ",
    garno: 0,
    ownerName: "นาง วิภา ทองคำ",
    LOCAT: "LEX",
    numberLand: "78900",
    typeLand: 1,
    province: "12",
    district: "01",
    subdistrict: "01",
    provDesc: "นนทบุรี",
    distDesc: "อ.เมืองนนทบุรี",
    subDistDesc: "สวนใหญ่",
    sequestrateStatus: 0,
    mortgageType: null,
  },
  // คนค้ำที่ 1 — ปทุมธานี
  {
    landId: 3002,
    invRoundId: 75,
    loanId: 770,
    contno: "1-0009999",
    assetOnlineId: 1501,
    invId: 540,
    customerId: 1900,
    investigation: 2,
    CUSCOD: "3130100112233",
    SNAM: "นาย",
    NAME1: "ชาติชาย",
    NAME2: "สุขสม",
    garno: 1,
    ownerName: "นาย ชาติชาย สุขสม",
    LOCAT: "LEX",
    numberLand: "33200",
    typeLand: 1,
    province: "13",
    district: "01",
    subdistrict: "02",
    provDesc: "ปทุมธานี",
    distDesc: "อ.เมืองปทุมธานี",
    subDistDesc: "บางปรอก",
    sequestrateStatus: 0,
    mortgageType: "จำนอง",
  },
];

const STATUS_META = {
  1: { label: "เลือกทรัพย์เพื่อยึด", color: "orange", icon: "📤" },
  2: { label: "รอลงเอกสารยึด", color: "blue", icon: "🕒" },
  3: { label: "ลงเอกสารสำเร็จ", color: "green", icon: "✅" },
};

const STATUS_KEYS = Object.keys(STATUS_META).map(Number);

const statusOptions = STATUS_KEYS.map((value) => ({
  value,
  ...STATUS_META[value],
}));

const StatusTag = ({ status }) => {
  const m = STATUS_META[status];
  if (!m) return <Tag>ไม่ระบุ</Tag>;
  return <Tag color={m.color}>{m.label}</Tag>;
};

const norm = (v) =>
  String(v ?? "")
    .trim()
    .toLowerCase();
const fullName = (r) =>
  `${r.SNAM || ""}${r.NAME1 || ""} ${r.NAME2 || ""}`.trim();
const customerType = (garno) =>
  garno === 0 ? "ผู้เช่าซื้อ" : garno ? `คนค้ำที่ ${garno}` : "-";

/* ──────────────────────────────────────── */

const Main = () => {
  const [dataArr] = useState(MOCK_ASSETS);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState("");
  const [processStatus, setProcessStatus] = useState(1);

  const [geo, setGeo] = useState({ province: [] });

  const [selZone, setSelZone] = useState(null);
  const [selProvince, setSelProvince] = useState(null);
  const [selDistrict, setSelDistrict] = useState(null);
  const [selSubDistrict, setSelSubDistrict] = useState(null);

  // modal state — เก็บ contract object ที่จะส่งไป SeizeAssetModal
  const [modalContract, setModalContract] = useState(null);

  /* ── Load GEO ── */
  useEffect(() => {
    let isMounted = true;
    const loadGeoData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(GET_GEO_ALL, {
          headers: HEADERS_EXPORT_BEN,
        });
        const d = res.data || {};
        if (isMounted) setGeo({ province: d.province || [] });
      } catch (error) {
        if (error.name !== "CanceledError" && isMounted)
          message.error("ไม่สามารถโหลดข้อมูลพื้นที่ได้");
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    loadGeoData();
    return () => {
      isMounted = false;
    };
  }, []);

  /* ── Geo helpers ── */
  const provToZone = useCallback(
    (provCode) => {
      const p = geo.province.find(
        (x) => String(x.provCode) === String(provCode),
      );
      return p ? p.groupArea : null;
    },
    [geo.province],
  );

  const provToZoneDesc = useCallback(
    (provCode) => {
      const p = geo.province.find(
        (x) => String(x.provCode) === String(provCode),
      );
      return p ? p.groupDesc : null;
    },
    [geo.province],
  );

  /* ── pool สำหรับสร้าง option ── */
  const areaSourceLands = useMemo(() => {
    const q = norm(searchInputTable);
    return dataArr.filter((item) => {
      if (processStatus != null && item.investigation !== processStatus)
        return false;
      if (q) {
        const hay = [item.contno, item.CUSCOD, fullName(item)]
          .map(norm)
          .some((v) => v.includes(q));
        if (!hay) return false;
      }
      return true;
    });
  }, [dataArr, processStatus, searchInputTable]);

  /* ── Cascading options ── */
  const zoneOptions = useMemo(() => {
    const map = new Map();
    areaSourceLands.forEach((r) => {
      const ga = provToZone(r.province);
      if (ga != null && !map.has(ga))
        map.set(ga, { value: ga, label: provToZoneDesc(r.province) });
    });
    return [...map.values()];
  }, [areaSourceLands, provToZone, provToZoneDesc]);

  const provinceOptions = useMemo(() => {
    const map = new Map();
    areaSourceLands.forEach((r) => {
      if (selZone != null && provToZone(r.province) !== selZone) return;
      if (!map.has(r.province))
        map.set(r.province, { value: String(r.province), label: r.provDesc });
    });
    return [...map.values()];
  }, [areaSourceLands, selZone, provToZone]);

  const districtOptions = useMemo(() => {
    const map = new Map();
    areaSourceLands.forEach((r) => {
      if (selProvince != null && String(r.province) !== String(selProvince))
        return;
      const key = `${r.province}|${r.district}`;
      if (!map.has(key)) map.set(key, { value: key, label: r.distDesc });
    });
    return [...map.values()];
  }, [areaSourceLands, selProvince]);

  const subDistrictOptions = useMemo(() => {
    if (selProvince == null) return [];
    const map = new Map();
    areaSourceLands.forEach((r) => {
      if (String(r.province) !== String(selProvince)) return;
      if (selDistrict != null && String(r.district) !== String(selDistrict))
        return;
      const key = `${r.province}|${r.district}|${r.subdistrict}`;
      if (!map.has(key)) map.set(key, { value: key, label: r.subDistDesc });
    });
    return [...map.values()];
  }, [areaSourceLands, selProvince, selDistrict]);

  /* ── Change handlers ── */
  const handleZoneChange = useCallback((z) => {
    setSelZone(z ?? null);
    setSelProvince(null);
    setSelDistrict(null);
    setSelSubDistrict(null);
  }, []);

  const handleProvinceChange = useCallback(
    (provCode) => {
      if (provCode == null) {
        setSelProvince(null);
        setSelDistrict(null);
        setSelSubDistrict(null);
        return;
      }
      setSelProvince(provCode);
      setSelZone(provToZone(provCode));
      setSelDistrict(null);
      setSelSubDistrict(null);
    },
    [provToZone],
  );

  const handleDistrictChange = useCallback(
    (composite) => {
      if (!composite) {
        setSelDistrict(null);
        setSelSubDistrict(null);
        return;
      }
      const [provCode, distCode] = composite.split("|");
      setSelProvince(provCode);
      setSelZone(provToZone(provCode));
      setSelDistrict(distCode);
      setSelSubDistrict(null);
    },
    [provToZone],
  );

  const handleSubDistrictChange = useCallback(
    (composite) => {
      if (!composite) {
        setSelSubDistrict(null);
        return;
      }
      const [provCode, distCode, subCode] = composite.split("|");
      setSelProvince(provCode);
      setSelZone(provToZone(provCode));
      setSelDistrict(distCode);
      setSelSubDistrict(subCode);
    },
    [provToZone],
  );

  const handleResetArea = useCallback(() => {
    setSelZone(null);
    setSelProvince(null);
    setSelDistrict(null);
    setSelSubDistrict(null);
  }, []);

  const handleResetFilter = useCallback(() => {
    setSearchInputTable("");
    setProcessStatus(null);
    handleResetArea();
    message.info("ล้างตัวกรองสำเร็จ");
  }, [handleResetArea]);

  const districtValue =
    selProvince != null && selDistrict != null
      ? `${selProvince}|${selDistrict}`
      : undefined;
  const subDistrictValue =
    selProvince != null && selDistrict != null && selSubDistrict != null
      ? `${selProvince}|${selDistrict}|${selSubDistrict}`
      : undefined;

  const hasAreaFilter =
    selZone != null ||
    selProvince != null ||
    selDistrict != null ||
    selSubDistrict != null;

  /* ── filter พื้นที่ ── */
  const matchesLocation = useCallback(
    (rec) => {
      if (!hasAreaFilter) return true;
      if (
        selSubDistrict != null &&
        String(rec.subdistrict) !== String(selSubDistrict)
      )
        return false;
      if (selDistrict != null && String(rec.district) !== String(selDistrict))
        return false;
      if (selProvince != null && String(rec.province) !== String(selProvince))
        return false;
      if (selZone != null && provToZone(rec.province) !== selZone) return false;
      return true;
    },
    [
      hasAreaFilter,
      selZone,
      selProvince,
      selDistrict,
      selSubDistrict,
      provToZone,
    ],
  );

  const filteredLands = useMemo(
    () => areaSourceLands.filter(matchesLocation),
    [areaSourceLands, matchesLocation],
  );

  /* ──────────────────────────────────────────────────────────────────
   * GROUP ตามสัญญาเท่านั้น (ไม่แยก customer / จังหวัด)
   * lands ทุกคนในสัญญาเดียวกัน → รวมไว้ใน group เดียว
   * ──────────────────────────────────────────────────────────────── */
  const groupedTable = useMemo(() => {
    // ดึง land ทุกแปลงของสัญญาที่ปรากฎใน filteredLands
    // (เราจะใส่ lands ทั้งหมดของสัญญานั้นจาก dataArr ลงไปใน modal)
    const contractsInFilter = new Set(filteredLands.map((r) => r.contno));

    const groups = new Map();
    for (const contno of contractsInFilter) {
      // รวม land ทุกแปลงของสัญญานี้จาก dataArr (ไม่กรองสถานะ/พื้นที่ — modal แสดงครบ)
      const allLands = dataArr.filter((r) => r.contno === contno);

      // ตัวแทนสัญญา: เอา garno=0 เป็น primary owner
      const primary = allLands.find((r) => r.garno === 0) || allLands[0];

      const statusCounts = STATUS_KEYS.reduce((acc, k) => {
        acc[k] = 0;
        return acc;
      }, {});
      allLands.forEach((l) => {
        if (statusCounts[l.investigation] != null)
          statusCounts[l.investigation] += 1;
      });

      groups.set(contno, {
        groupKey: contno,
        contno,
        CUSCOD: primary.CUSCOD,
        SNAM: primary.SNAM,
        NAME1: primary.NAME1,
        NAME2: primary.NAME2,
        ownerName: primary.ownerName,
        lands: allLands,
        count: allLands.length,
        statusCounts,
        // สรุปจังหวัดที่พบ
        provinces: [...new Set(allLands.map((l) => l.provDesc))].join(", "),
      });
    }

    const arr = [...groups.values()];
    arr.sort((a, b) => String(a.contno).localeCompare(String(b.contno), "th"));
    return arr;
  }, [filteredLands, dataArr]);

  const totalLands = useMemo(
    () => groupedTable.reduce((s, g) => s + g.count, 0),
    [groupedTable],
  );

  /* ── สถานะรวม ── */
  const renderGroupStatus = (g) => {
    const present = STATUS_KEYS.filter((k) => g.statusCounts[k] > 0);
    if (present.length === 0) return <span style={{ color: "#bbb" }}>-</span>;
    return (
      <Space size={4} wrap>
        {present.map((k) => (
          <Tag key={k} color={STATUS_META[k].color}>
            {STATUS_META[k].label} ({g.statusCounts[k]})
          </Tag>
        ))}
      </Space>
    );
  };

  /* ── expanded row: แสดงทรัพย์ทุกแปลงในสัญญา (รวมทุกคน) ── */
  const expandedRowRender = (group) => {
    const detailColumns = [
      {
        title: "ลำดับ",
        key: "i",
        align: "center",
        width: 60,
        render: (_, __, i) => i + 1,
      },
      {
        title: "เจ้าของ",
        key: "owner",
        align: "left",
        render: (_, r) => (
          <Space direction="vertical" size={0}>
            <Text strong style={{ fontSize: 13 }}>
              {r.ownerName}
            </Text>
            <Tag
              color={r.garno === 0 ? "blue" : "purple"}
              style={{ margin: 0 }}
            >
              {customerType(r.garno)}
            </Tag>
          </Space>
        ),
      },
      {
        title: "เลขที่ดิน",
        dataIndex: "numberLand",
        key: "numberLand",
        align: "center",
      },
      {
        title: "ประเภท",
        dataIndex: "typeLand",
        key: "typeLand",
        align: "center",
        render: (v) => (v === 1 ? "โฉนด" : v === 2 ? "นส.3" : (v ?? "-")),
      },
      {
        title: "จังหวัด",
        dataIndex: "provDesc",
        key: "provDesc",
        align: "center",
      },
      {
        title: "อำเภอ",
        dataIndex: "distDesc",
        key: "distDesc",
        align: "center",
      },
      {
        title: "ตำบล",
        dataIndex: "subDistDesc",
        key: "subDistDesc",
        align: "center",
      },
      {
        title: "สถานะการสืบ",
        key: "inv",
        align: "center",
        render: (_, r) => <StatusTag status={r.investigation} />,
      },
    ];

    return (
      <Table
        size="small"
        columns={detailColumns}
        dataSource={group.lands}
        rowKey={(r) => r.landId}
        pagination={false}
        style={{ background: "#fafafa", borderRadius: 8 }}
      />
    );
  };

  /* ── open modal พร้อม contract object ── */
  const openSeizeModal = (group) => {
    setModalContract({
      contno: group.contno,
      ownerName: group.ownerName,
      lands: group.lands,
    });
  };

  /* ── คอลัมน์หลัก ── */
  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 70,
      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "contno",
      key: "contno",
      align: "center",
      width: 140,
      sorter: (a, b) => String(a.contno).localeCompare(String(b.contno), "th"),
      defaultSortOrder: "ascend",
      render: (v) => <Text strong>{v}</Text>,
    },
    {
      title: "ชื่อผู้เช่าซื้อ",
      key: "fullName",
      align: "left",
      render: (_, g) => g.ownerName,
    },
    {
      title: "จังหวัด (ทรัพย์ทั้งหมด)",
      key: "provinces",
      align: "left",
      render: (_, g) => (
        <Text type="secondary" style={{ fontSize: 12 }}>
          {g.provinces}
        </Text>
      ),
    },
    {
      title: "จำนวนแปลง",
      key: "count",
      align: "center",
      width: 110,
      render: (_, g) => <Tag color="purple">{g.count} แปลง</Tag>,
    },
    {
      title: "สถานะการสืบ",
      key: "investigation",
      align: "center",
      width: 200,
      render: (_, g) => renderGroupStatus(g),
    },
    {
      title: "จัดการ",
      key: "action",
      align: "center",
      width: 150,
      render: (_, g) => (
        <>
          {processStatus === 1 && (
            <Button
              size="small"
              type="primary"
              icon={<FileSearchOutlined />}
              onClick={() => openSeizeModal(g)}
            >
              สร้างรายงานยึด
            </Button>
          )}
          {processStatus === 2 && (
            <Button
              size="small"
              icon={<FileSearchOutlined />}
              onClick={() => openSeizeModal(g)}
            >
              อัพโหลดเอกสารยึด
            </Button>
          )}
          {processStatus === 3 && (
            <Button
              size="small"
              icon={<FileSearchOutlined />}
              onClick={() => message.info(`ดูข้อมูลสัญญา ${g.contno}`)}
            >
              ดูข้อมูล
            </Button>
          )}
        </>
      ),
    },
  ];

  /* ── Render ── */
  return (
    <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
      {/* ── Filter bar ── */}
      <Card
        style={{
          marginBottom: 8,
          borderRadius: 12,
          border: "1px solid #ffcb05",
          background: "#fffdf0",
        }}
      >
        <Row align="middle" gutter={[8, 8]}>
          <Col xs={24} md={10}>
            <Space size={8} align="center">
              <FilterOutlined style={{ color: "#efa420" }} />
              <Text strong style={{ color: "#efa420" }}>
                เลือกสถานะ
              </Text>
              <Select
                size="large"
                style={{ minWidth: 210 }}
                placeholder="เลือกสถานะ"
                value={processStatus}
                allowClear
                onChange={(v) => setProcessStatus(v ?? null)}
                optionLabelProp="label"
              >
                {statusOptions.map(({ value, icon, label }) => (
                  <Option key={value} value={value} label={`${icon} ${label}`}>
                    <Space>
                      <span>{icon}</span>
                      <span>{label}</span>
                    </Space>
                  </Option>
                ))}
              </Select>
            </Space>
          </Col>

          <Col xs={24} md={14} style={{ textAlign: "end" }}>
            <Space size={10} wrap>
              <Input
                placeholder="ค้นหาเลขสัญญา, ชื่อ"
                value={searchInputTable}
                onChange={(e) => setSearchInputTable(e.target.value)}
                style={{ width: 240, borderRadius: 8 }}
                size="small"
                allowClear
                suffix={<span>🔍</span>}
              />
              <Button
                icon={<ReloadOutlined />}
                onClick={handleResetFilter}
                size="large"
                style={{
                  borderRadius: 8,
                  backgroundColor: "#fff1f0",
                  borderColor: "#ffa39e",
                  color: "#cf1322",
                }}
              >
                ล้างตัวกรอง
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>

      {/* ── Table ── */}
      <Card>
        <Table
          size="small"
          columns={columns}
          dataSource={groupedTable}
          rowKey="groupKey"
          scroll={{ x: 1000 }}
          expandable={{
            expandedRowRender,
            rowExpandable: (g) => g.lands?.length > 0,
          }}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            showTotal: (total) => `ทั้งหมด ${total} สัญญา`,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          footer={() => (
            <p style={{ margin: 0 }}>
              จำนวนสัญญา {groupedTable.length} | จำนวนแปลงทั้งหมด {totalLands}
            </p>
          )}
        />
      </Card>

      {/* ── SeizeAssetModal ── */}
      {modalContract && (
        <SeizeAssetModal
          open={!!modalContract}
          close={() => setModalContract(null)}
          contract={modalContract}
          onSaved={(seizeList) => {
            console.log("seizeList:", seizeList);
            // TODO: call API บันทึก seizeList
          }}
        />
      )}
    </Spin>
  );
};

const MainSelectEnforceAsset = MotionHoc(Main);
export default MainSelectEnforceAsset;
